/**
 * Ported verbatim from student-dashboard-v2/src/utils/getS3Url.ts so S3 key
 * signing behaves identically to the student website.
 */
import {
  getPresignedReadUrl,
  getPresignedReadUrls,
  type PresignedReadUrlInput,
} from './mediaServiceClient';

const decodeS3Key = (path: string): string =>
  decodeURIComponent(path).replace(/\+/g, ' ').replace(/^\/+/, '');

export const getFileUrlByKey = async (
  path: string,
  customBucketName?: string,
  validateObjectExistence = true,
): Promise<string | null> => {
  if (!path || path === 'undefined') return null;

  try {
    const result = await getPresignedReadUrl({
      key: decodeS3Key(path),
      bucket: customBucketName,
      validateObjectExistence,
    });
    return result.url;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error('Failed to get S3 read URL:', error.message);
    }
    return null;
  }
};

export const getFileUrlsByKeys = async (
  items: Array<{
    path: string;
    customBucketName?: string;
    validateObjectExistence?: boolean;
  }>,
): Promise<Record<string, string>> => {
  const validItems = items.filter(
    item => item.path && item.path !== 'undefined',
  );
  if (!validItems.length) return {};

  try {
    const requests: PresignedReadUrlInput[] = validItems.map(item => ({
      key: decodeS3Key(item.path),
      bucket: item.customBucketName,
      validateObjectExistence: item.validateObjectExistence ?? true,
    }));

    const results = await getPresignedReadUrls(requests);

    return results.reduce<Record<string, string>>((acc, result, index) => {
      acc[validItems[index].path] = result.url;
      return acc;
    }, {});
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error('Failed to get batch S3 read URLs:', error.message);
    }
    return {};
  }
};
